import { fromJS } from 'immutable';
import MODULE_NAME from '../constants/moduleName';

export const SET_AUTH_STATUS = `modules/${MODULE_NAME}/SET_AUTH_STATUS`;

export const initialState = fromJS({
  authenticated: false,
  loaded: false,
});

// eslint-disable-next-line default-param-last -- this will have lasting effects ignore for now
export default function reducer(state = initialState, action) {
  switch (action?.type) {
    case SET_AUTH_STATUS:
      return state
        .set('authenticated', !!action.authenticated)
        .set('loaded', true);
    default:
      return state;
  }
}

export function setAuthentication(authenticated = false) {
  return {
    type: SET_AUTH_STATUS,
    authenticated,
  };
}
